module.exports = __webpack_public_path__ + "img/title.94c4f7c1.png";